module.exports = __webpack_public_path__ + "static/media/tangyuzhe.be5a14c7.png";